import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

import { filter } from 'rxjs';

import { SearchCriteriaSortFieldEnum } from '../../../../api/mentions/enum/search-criteria-sort-field.enum';

import { ChartDisplayElementModel } from '../../../Reports/models/chart-display-element.model';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { Mention } from '../../../Mentions/models/mention';
import { SeriesModel } from '../../../Charts/models/series.model';


@Component({
    selector: 'agpr-top-posts-chart',
    templateUrl: './top-posts-chart.component.html',
    styleUrls: ['./top-posts-chart.component.scss'],
    standalone: false
})
export class TopPostsChartComponent implements AfterViewInit {
    readonly messageSeverities = messageSeverityEnum;
    readonly agprComponentStyle = AgprComponentStyleEnum;
    readonly id = 'topPostsChart';

    @Input() header: string = '';
    @Input() series: SeriesModel[];
    @Input() preview: boolean = false;
    @Output() dataChange = new EventEmitter<boolean>();
    @Input()
    set displayElement(displayElement: ChartDisplayElementModel) {
        this._displayElement = displayElement;
        if (this.displayElement.topMentionsSortField === SearchCriteriaSortFieldEnum.custom) {
            // curated mentions are saved with the displayElement
            this.displayElement.series[0].mentionProvider.next(this.displayElement.topCuratedMentions);
        }
    }
    get displayElement() {
        return this._displayElement;
    }

    _displayElement: ChartDisplayElementModel;
    data: Mention[];

    constructor() {}

    ngAfterViewInit(): void {
        this.series[0].mentionProvider.pipe(filter(x => !!x)).subscribe(mentions => {
            this.data = mentions;
            this.dataChange.emit(true);
        });
    }
}
